import { combineReducers } from 'redux'
import { combineForms } from 'react-redux-form'

import * as h2Api from '../h2Api'
import * as actions from '../actions/capActions'

const initialViewState = {
  step: 1,
  selected: null,
  preferencesModalOpen: false
}
const view = (state = initialViewState, action) => {
  switch (action.type) {
    case actions.PREFERENCES_MODAL:
      return {
        ...state,
        preferencesModalOpen: action.isOpen
      }

    case actions.UPDATE_VIEW: {
      const next = { ...state, ...action.contents }

      //debugger;
      return next
    }
    default:
      return state
  }
}

export default combineReducers({
  view,
  listRequest: h2Api.restReducer(actions.LIST_PLANS),
  getRequest: h2Api.restReducer(actions.GET_PLAN),
  updateRequest: h2Api.restReducer(actions.UPDATE_PLAN),
  createRequest: h2Api.restReducer(actions.CREATE_PLAN),
  deleteRequest: h2Api.restReducer(actions.DELETE_PLAN),
  occupationSearchRequest: h2Api.restReducer(actions.SEARCH_OCCUPATIONS),
  relevantOccupationsRequest: h2Api.restReducer(actions.RELEVANT_OCCUPATIONS),
  relevantBudgetRequest: h2Api.restReducer(actions.RELEVANT_BUDGETS),
  relevantProgramsRequest: h2Api.restReducer(actions.RELEVANT_PROGRAMS),
  relevantInstitutionsRequest: h2Api.restReducer(actions.RELEVANT_INSTITUTIONS),
  forms: combineForms(
    {
      create: { occupation: null },
      loan: { rate: 7, term: 10 }
    },
    'cap.forms'
  )
})
